import React from 'react'
import type { AuctionBlueprintOnlineReactiveArgs } from '@adc/blueprint'
import { PurchaseTitleReport } from '../../components/purchaseTitleReport'

type Listing = AuctionBlueprintOnlineReactiveArgs['listing']

interface AdditionalAuctionDetailsProps {
  listing: Listing
}

/**
 * Simple wrapper to allow for other cards or other content in the additional details area in the future.
 */
export const AdditionalAuctionDetails = ({
  listing,
}: AdditionalAuctionDetailsProps) => {
  return (
    <>
      <PurchaseTitleReport listing={listing} />
    </>
  )
}
